import Const from 'constants';
import Action from 'actions';

const ProjectedOwnershipForce = {
    setProjectedOwnershipForceFromStorage(data) {
        return {
            type: Const.PROJECTED_OWNERSHIP_FORCE_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    setProjectedOwnershipForceIsEnabled(isEnabled) {
        return (dispatch) => {
            dispatch({
                type: Const.PROJECTED_OWNERSHIP_FORCE_SET_IS_ENABLED,
                isEnabled,
            });
            dispatch(this.saveProjectedOwnershipForceToStorage());
        };
    },

    setRangeOfProjectedOwnershipForce(quantity) {
        return (dispatch) => {
            dispatch({
                type: Const.PROJECTED_OWNERSHIP_FORCE_SET_RANGE,
                quantity,
            });
            dispatch(this.saveProjectedOwnershipForceToStorage());
        };
    },

    setIgnoredPositionOfProjectedOwnershipForce(position, isIgnored) {
        return (dispatch) => {
            dispatch({
                type: Const.PROJECTED_OWNERSHIP_FORCE_SET_IGNORED_POSITION,
                position,
                isIgnored,
            });
            dispatch(this.saveProjectedOwnershipForceToStorage());
        };
    },

    setSubPercentOfProjectedOwnershipForce(value) {
        return (dispatch) => {
            dispatch({
                type: Const.PROJECTED_OWNERSHIP_FORCE_SET_SUB_PERCENT,
                value,
            });
            dispatch(this.saveProjectedOwnershipForceToStorage());
        };
    },

    saveProjectedOwnershipForceToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('projectedOwnershipForce', function (state) {
                    const {projectedOwnershipForce} = state;

                    return projectedOwnershipForce.all();
                }),
            );
        };
    },
};

export default Object.assign(Action, ProjectedOwnershipForce);
